module.exports = require('./lib/StreamCache');



//////////////////
// WEBPACK FOOTER
// ./~/stream-cache/index.js
// module id = 3951
// module chunks = 0